import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import {alertActions, contracterActions} from '../../store/actions'
import Input from "../input";
import history from "../../route/history";
import Calendar from "../calendar/Calendar";
import moment from "moment";
import {commons} from "../../hook/common";

/**
 * 수출근거서류 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopupGetItem = props => {
  const [ state, setState ] = useState({});
  const [ itemList, setItemList] = useState([]);

  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2;

    setItemList(list)

  }, []);

  const handleClose = () => {
    props.isShowItems(false);
  }

  const selectItem = (crtItemSeq) => {
    props.selectItems(crtItemSeq);

  }

  return <React.Fragment>
      <div className="modal-overlay normal modal-certificate">
        <div className="modal modal-Full">
          <div className="modal-content">

            <div className="modal-header flex-sb">
              <div className="modal-title dis-flex">
                수출근거서류 정보
              </div>

              <button
                type="button"
                className="icon-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span
                  aria-hidden="true"
                >
                  &times;
                </span>
              </button>
            </div>


            <div className="modal-body">
                <div className="table">
                    <div className="row header border">
                      <div className="cell w-7">HS부호</div>
                      <div className="cell w-10">품명</div>
                      <div className="cell ">규격</div>
                      <div className="cell w-10">수량</div>
                      <div className="cell w-10">구매일</div>
                      <div className="cell w-10">단가</div>
                      <div className="cell w-7">금액</div>
                    </div>
                    {
                      itemList?.length > 0 ?
                          itemList?.map((item, index) => {
                            return <div className="row" key={index} onClick={() => selectItem(item.crtItemSeq)}>
                              <div className="cell" data-title={"HS부호"}>{item.hsCd}</div>
                              <div className="cell" data-title={"품명"}>{item.itemnm}</div>
                              <div className="cell" data-title={"규격"}>{item.itemdeftxt}</div>
                              <div className="cell" data-title={"수량"}>{commons.addComma(item.grcnt)}</div>
                              <div className="cell" data-title={"구매일"}>{moment(item.crtYmd).format('YYYY-MM-DD')}</div>
                              <div className="cell" data-title={"단가"}>{commons.addComma(item.baseAmt)}</div>
                              <div className="cell" data-title={"금액"}>{commons.addComma(item.gramt)}</div>
                            </div>
                          })
                          : <div>검색된 자료가 없습니다.</div>
                    }

                </div>

            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
}

const mapStateToProps = state => {
  return {
  }
}

const actionCreators = {
  selectItems: contracterActions.selectItems,
  isShowItems: contracterActions.isShowItems,
}

export default connect(
  mapStateToProps,
  actionCreators
)(PopupGetItem)
